import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";

export const KeyClockProblem = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="keyclock-advantage">
        <div className="inner">
          <div className="content">
            <div className="descript">
              <div className="img-icon">
                <img src="//files.authing.co/authing-website/solution-star.png" alt="authing solution keycloak" />
              </div>
              <div style={{ display: "flex" }}>
                <i className="icon authing-icon authing-yinhao quote-icon"></i>
                <span className="descript-text">{t("solution.keycloak.problem.description")}</span>
                <span className="quote-icon-rotate">
                  <i className="icon authing-icon authing-yinhao quote-icon"></i>
                </span>
              </div>
            </div>
            <Title title={t("solution.keycloak.problem.title")} />
            <div className="advantage-warp">
              <div className="advantage">
                <div className="title">{t("solution.keycloak.problem.advantage.title")}</div>
                <div className="content-warp">
                  <div className="item-list">
                    <span className="icon">
                      <i className="icon authing-icon authing-mianfei icon-style"></i>
                    </span>
                    <span className="text">{t("solution.keycloak.problem.advantage.item1")}</span>
                  </div>
                  <div className="item-list">
                    <span className="icon">
                      <i className="icon authing-icon authing-rocket icon-style"></i>
                    </span>
                    <span className="text">{t("solution.keycloak.problem.advantage.item2")}</span>
                  </div>
                  <div className="item-list">
                    <span className="icon">
                      <i className="icon authing-icon authing-linghuo icon-style"></i>
                    </span>
                    <span className="text">{t("solution.keycloak.problem.advantage.item3")}</span>
                  </div>
                  <div className="item-list">
                    <span className="icon">
                      <i className="icon authing-icon authing-kaifang icon-style"></i>
                    </span>
                    <span className="text">{t("solution.keycloak.problem.advantage.item4")}</span>
                  </div>
                </div>
              </div>
              <div className="question">
                <div className="title">{t("solution.keycloak.problem.question.title")}</div>
                <div className="content-warp">
                  <p>{t("solution.keycloak.problem.question.descript1")}</p>
                  <p>{t("solution.keycloak.problem.question.descript2")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
